function nexusImageUrlTransformation(url, wSize, isPopup) {
	let index = url?.indexOf("Nexus");

	if (isPopup) {
		index = url?.indexOf("f_auto,q_auto");
	}

	if (index !== -1) {
		const firstPart = url?.substring(0, index);
		let secondPart = url?.substring(index + 6);

		if (isPopup) {
			secondPart = url?.substring(index + 14);
		}

		if (wSize && !isPopup) {
			return `https:${firstPart}f_auto,q_auto,w_${wSize}/Nexus/${secondPart}`;
		}

		if (wSize && isPopup) {
			return `https:${firstPart}f_auto,q_auto,w_${wSize}/${secondPart}`;
		}

		return `https:${firstPart}f_auto,q_auto/Nexus/${secondPart}`;
	}
	return url;
}
export default nexusImageUrlTransformation;
